import React, { useEffect, useRef } from "react";

import logoWhite from "../../assets/images/schmodelplain-withR-white.png";
import styles from "./application.module.css";

const TOTAL_STEPS = 6;

const Wordmark = () => (
  <div className={styles.masthead}>
    <img src={logoWhite} className={styles.logo} alt="Schmodel" />
  </div>
);

const Progress = ({ step, totalSteps }) => (
  <div className={styles.progress}>
    <div className={styles.stepLabel}>
      Step {step} of {totalSteps}
    </div>
    <div
      className={styles.progressTrack}
      style={{ gridTemplateColumns: `repeat(${totalSteps}, minmax(0, 1fr))` }}
      role="progressbar"
      aria-valuenow={step}
      aria-valuemin={1}
      aria-valuemax={totalSteps}
      aria-label={`Step ${step} of ${totalSteps}`}
    >
      {Array.from({ length: totalSteps }, (_, i) => (
        <div
          key={i}
          className={`${styles.progressSegment} ${i < step ? styles.progressSegmentDone : ""}`}
        />
      ))}
    </div>
  </div>
);

const BackLink = ({ onBack, label }) => (
  <button type="button" className={styles.back} onClick={onBack}>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
      <path d="M10 3 5 8l5 5" />
    </svg>
    {label}
  </button>
);

// `as` lets a step render as a <form>, so the footer's submit stays wired to the fields.
const ApplicationLayout = ({
  step,
  totalSteps = TOTAL_STEPS,
  onBack,
  backLabel = "Back",
  aboveTitle,
  title,
  intro,
  footer,
  children,
  centred = false,
  as: Element = "div",
  ...elementProps
}) => {
  const top = useRef();

  useEffect(() => {
    if (top.current && top.current.scrollIntoView) {
      top.current.scrollIntoView({ block: "start" });
    }
  }, []);

  return (
    <div className={styles.page} ref={top}>
      <Element className={`${styles.frame} ${centred ? styles.frameCentred : ""}`} {...elementProps}>
        <Wordmark />
        <div className={styles.body}>
          {step && <Progress step={step} totalSteps={totalSteps} />}
          {onBack && <BackLink onBack={onBack} label={backLabel} />}
          {aboveTitle && <div className={styles.aboveTitle}>{aboveTitle}</div>}
          {title && <h1 className={styles.title}>{title}</h1>}
          {intro && <p className={styles.intro}>{intro}</p>}
          <div className={styles.content}>{children}</div>
          {footer && <div className={styles.footer}>{footer}</div>}
        </div>
      </Element>
    </div>
  );
};

export default ApplicationLayout;
export { styles as applicationStyles };
